import { API } from './resources'

export default {
  loadToComment: (postID, id) => {
    return API.get(`posts/${postID}/comments/${id}`)
  },
  create: (data) => {
    return API.post('/comments', data)
  },
  get: (id) => {
    return API.get(`/comments/${id}`)
  },
  update: (id, body, attachments) => {
    return API.put(`/comments/${id}`, { body, attachments })
  },
  delete: (id) => {
    return API.delete(`/comments/${id}`)
  },
  getReplies: (id) => {
    return API.get(`/comments/${id}/replies`)
  },
  getLikes: (id, limit, offset) => {
    return API.get(`/comments/${id}/likes`, { params: { limit, offset } })
  },
  createReply: (id, data) => {
    return API.post(`/comments/${id}/replies`, data)
  },
  hasLiked: (id, username) => {
    return API.get(`/comments/${id}/like/${username}`)
  },
  like: (id) => {
    return API.post(`/comments/${id}/like`)
  },
  unlike: (id) => {
    return API.delete(`/comments/${id}/like`)
  },
  getAttachments: (id) => {
    return API.get(`/comments/${id}/attachments/`)
  },
  addAttachment: (id, data) => {
    return API.post(`/comments/${id}/attachments`, data)
  },
  updateAttachment: (id, attachmentID, data) => {
    return API.put(`/comments/${id}/attachments/${attachmentID}`, data)
  },
  deleteAttachment: (id, attachmentID) => {
    return API.delete(`/comments/${id}/attachments/${attachmentID}`)
  },
  copyAttachment: (id, attachmentID) => {
    return API.post(`/comments/${id}/attachments/${attachmentID}/copy`)
  }
}
